import { render, staticRenderFns } from "./InboxListContent.vue?vue&type=template&id=5b26399e"
import script from "./InboxListContent.vue?vue&type=script&lang=js"
export * from "./InboxListContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports